import React, { Component } from 'react';
import {
    CTable,
    CTableHead,
    CTableRow,
    CTableHeaderCell,
    CTableBody,
    CTableDataCell,
    CBadge,
    CSpinner,
    CRow,
    CCol,
    CFormSelect,
    CFormInput
} from '@coreui/react'
import {
    cilPencil,
    cilSearch,
    cilXCircle,
    cilPlus,
    cilBan,
    cilCheck
} from '@coreui/icons'
import TableActions from '../../components/TableActions'
import AppButton from 'src/components/AppButton'
import ServerConnector from 'src/ServerConnector'
import PageHeader from 'src/components/PageHeader';
import { replaceEmpty } from 'src/util/StringUtil';

class ManageSubTopic extends Component {
    constructor(props) {
        super(props);

        this.state = {
            spinner: true,
            sub_topic_list: [],
            topic_list: [],
            selected_top_seq: -1,
            subject_list: [],
            selected_sub_seq: -1,
            search_str: ""
        };
    }

    componentDidMount() {

        this.loadSubjectList();
        this.loadData();
    }

    loadSubjectList() {

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_ALL_SUBJECTS"
        }
        connector.postData(dataMap, (data) => { // success
            this.setState({
                subject_list: data.data
            });
        }, (err_cd, msg, data) => { // failure
            this.setState({
                spinner: false
            });
        })
    }

    loadTopicList() {

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_ALL_TOPICS",
            "subject_seq": String(this.state.selected_sub_seq)
        }
        connector.postData(dataMap, (data) => { // success
            this.setState({
                topic_list: data.data,
                selected_top_seq: -1
            });
        }, (err_cd, msg, data) => { // failure
            this.setState({
                spinner: false,
                topic_list: [],
                selected_top_seq: -1
            });
        })
    }

    loadData() {
        this.setState({
            spinner: true
        });
        let connector = new ServerConnector();
        let dataMap = {
            _action_code: "GET_ALL_SUBTOPICS",
            topic_seq: parseInt(this.state.selected_top_seq),
            subject_seq: parseInt(this.state.selected_sub_seq)
        }

        if (this.state.search_str.length != 0) {
            dataMap["search_str"] = this.state.search_str;
        }

        connector.postData(dataMap, (data) => { // success
            this.setState({
                spinner: false,
                sub_topic_list: data.data
            });
        }, (err_cd, msg, data) => { // failure
            this.setState({
                spinner: false,
                sub_topic_list: []
            });
        })
    }

    onTopicSelection(event) {
        this.setState({
            selected_top_seq: event.target.value
        })
    }

    onSubjectSelection(event) {
        this.setState({
            selected_sub_seq: event.target.value
        }, () => {
            this.loadTopicList();
        })
    }

    confirmStatusChange(subtopic_seq, action) {

        var msg = "Do you want to deactivate this Sub Topic?";
        if (action == "REACTIVATION") {
            msg = "Do you want to activate this Sub Topic?";
        }

        this.props.showConfirmation(
            "Confirmation",
            msg,
            "Yes",
            "No",
            null,
            () => { this.statusChange(subtopic_seq, action) }
        )
    }

    statusChange(subtopic_seq, action) {

        this.props.showPageSpinner(true);

        var newStatus = "INACTIVE";
        if (action == "REACTIVATION") {
            newStatus = "ACTIVE";
        }

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "SET_SUBTOPIC_STATUS",
            "subtopic_seq": subtopic_seq,
            "status": newStatus
        }
        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            this.props.showAlert("Success", data.msg, "Ok", null, () => {
                this.loadData()
            })
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);

            this.props.showAlert("Error", msg, "Ok", null, null);
        })
    }

    updateSearchInput(event) {

        this.setState({
            search_str: event.target.value
        });
    }

    render() {
        return (
            <>
                <PageHeader page_name={this.props.page_name} >
                    <AppButton
                        color="primary"
                        name="Add Sub Topics"
                        icon={cilPlus}
                        isLoading={false}
                        onClick={() => this.props.navigate("add_subtopic", { subtopic_seq: -999 })} />
                </PageHeader>
                <CRow>
                    <CCol md="3">
                        <CFormSelect value={this.state.selected_sub_seq} onChange={(event) => { this.onSubjectSelection(event) }}>
                            <option value={-1}>Select Subject</option>
                            {
                                this.state.subject_list.map((object, index) => {
                                    return (
                                        <option key={String(index)}
                                            value={object.subject_seq}>{object.subject_name}

                                        </option>
                                    )
                                })
                            }

                        </CFormSelect>
                    </CCol>
                    <CCol md="3">
                        <CFormSelect value={this.state.selected_top_seq} onChange={(event) => { this.onTopicSelection(event) }}>
                            <option value="0">Select Topic</option>
                            {
                                this.state.topic_list.map((object, index) => {
                                    return (
                                        <option key={String(index)}
                                            value={object.topic_seq}>{object.topic_name}

                                        </option>
                                    )
                                })
                            }
                        </CFormSelect>
                    </CCol>
                    <CCol md="3">
                        <CFormInput
                            type="text"
                            placeholder="Search"
                            onChange={(event) => { this.updateSearchInput(event) }}
                            value={this.state.search_str} />
                    </CCol>
                    <CCol md="3">
                        <AppButton
                            color="primary"
                            name="Search"
                            icon={cilSearch}
                            isLoading={false}
                            onClick={() => { this.loadData(); }} />
                    </CCol>
                </CRow>
                {
                    this.state.spinner ?
                        <div className="spinnerHolder">
                            <CSpinner color="primary" />
                        </div>
                        : null
                }
                <CTable className="listTable">
                    <CTableHead>
                        <CTableRow>
                            <CTableHeaderCell style={{ width: '10%' }} scope="col">ID</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '35%' }} scope="col">Sub Topic Name</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '35%' }} scope="col">Description</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '10%' }} scope="col">Status</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '10%' }} scope="col">Actions</CTableHeaderCell>
                        </CTableRow>
                    </CTableHead>
                    <CTableBody>
                        {
                            this.state.sub_topic_list.map((object, index) => {
                                const menuList = [
                                    {
                                        name: "Edit",
                                        icon: cilPencil,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE",
                                        onClick: () => { this.props.navigate("add_subtopic", { subtopic_seq: object.subtopic_seq }) },
                                        data: null
                                    },
                                    {
                                        name: "View",
                                        icon: cilSearch,
                                        isLoading: false,
                                        visible: true,
                                        onClick: () => { this.props.navigate("view_subtopic", { subtopic_seq: object.subtopic_seq }) },
                                        data: null
                                    },
                                    {
                                        name: "Deactivate",
                                        icon: cilBan,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE",
                                        onClick: () => { this.confirmStatusChange(object.subtopic_seq, "DEACTIVATION") },
                                        data: null
                                    },
                                    {
                                        name: "Activate",
                                        icon: cilCheck,
                                        isLoading: false,
                                        visible: object.status != "ACTIVE",
                                        onClick: () => { this.confirmStatusChange(object.subtopic_seq, "REACTIVATION") },
                                        data: null
                                    }
                                ];
                                return (
                                    <CTableRow key={String(index)}>
                                        <CTableDataCell scope="row">{object.subtopic_seq}</CTableDataCell>
                                        <CTableDataCell scope="row">{replaceEmpty(object.subtopic_name)}</CTableDataCell>
                                        <CTableDataCell>{replaceEmpty(object.description)}</CTableDataCell>
                                        <CTableDataCell>
                                            <CBadge color={object.status == "ACTIVE" ? "primary" : "danger"} shape="rounded-pill" size="sm">{object.status}</CBadge>
                                        </CTableDataCell>
                                        <CTableDataCell>
                                            <TableActions
                                                key={String(object.subtopic_seq) + object.status}
                                                actions={menuList}
                                                minCount="1" />
                                        </CTableDataCell>
                                    </CTableRow>
                                )
                            })
                        }
                        {
                            this.state.sub_topic_list.length == 0 ?
                                <CTableRow>
                                    <CTableDataCell colSpan={5} className="alignCenter">No Data Available</CTableDataCell>
                                </CTableRow>
                                :
                                null
                        }
                    </CTableBody>
                </CTable>
            </>
        );
    }
}

export default ManageSubTopic;